import React, { useCallback, useRef, useState } from "react";
import {
  Button,
  Card,
  Flex,
  TextField,
  IconButton,
  TextArea,
} from "@radix-ui/themes";
import { ArrowUpIcon } from "@radix-ui/react-icons";
import { ChatBubbleIcon } from "@radix-ui/react-icons";
import { useMediaQuery } from "react-responsive";

interface CSATCommentProps {
  csatCommentText?: string;
  onCSATComment: (comment: string) => void;
  onShow: () => void;
}

export function CSATComment({
  csatCommentText = "Add a comment",
  onCSATComment,
  onShow,
}: CSATCommentProps) {
  const isSmallScreen = useMediaQuery({ query: "(max-width: 520px)" });

  const [comment, setComment] = useState("");

  const textAreaRef = useRef<HTMLTextAreaElement | null>(null);

  const handleSubmitComment = useCallback(() => {
    onCSATComment(comment);
  }, [comment, onCSATComment]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
      const isMobile = /Mobi|Android/i.test(navigator.userAgent);
      if (!isMobile && event.key === "Enter" && !event.shiftKey) {
        handleSubmitComment();
        event.preventDefault();
      }
    },
    [handleSubmitComment]
  );

  const setTextAreaRef = useCallback((el: HTMLTextAreaElement | null) => {
    textAreaRef.current = el;
    el?.focus();
  }, []);

  return (
    <Flex
      flexGrow={"1"}
      direction={"column"}
      gap={"5"}
      style={{
        background:
          "linear-gradient(260.74deg, rgba(249, 243, 227, 0.35) 4.89%, rgba(226, 234, 255, 0.35) 101.01%)",
        padding: "8px 12px",
        borderRadius: "8px",
      }}
    >
      <Card variant="classic" size={"3"} className={"qc-Chat__CSAT__Comment"}>
        <TextArea
          ref={setTextAreaRef}
          placeholder={csatCommentText}
          value={comment}
          onChange={(event) => setComment(event.target.value)}
          style={{
            flexGrow: "1",
            boxShadow: "none",
            outline: "none",
          }}
          size={isSmallScreen ? "3" : "2"}
          onKeyDown={handleKeyDown}
        />

        <IconButton
          color="gray"
          variant="solid"
          radius="full"
          highContrast
          onClick={handleSubmitComment}
          aria-label="Send CSAT comment"
        >
          <ArrowUpIcon width="15" height="15" />
        </IconButton>
      </Card>
    </Flex>
  );
}
